export default __webpack_public_path__ + "static/media/ls1_g05.9ab4f684.png";